export default __webpack_public_path__ + "deep-purple.png";